export default __webpack_public_path__ + "static/team_retreat_1-eb180dd44742a0a9301bfc585d470f3a.jpg";